<div class="preloader">
    <div class="spinner"></div>
</div>